import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

// import HOCS
import withLayout from '../../hoc/Layout/SurveyLayout';
import wellnessCenterAuth from '../../hoc/Layout/WellnessCenterLayout';

// Import route components
import WellnessCenterAccess from './WellnessCenterAccess/WellnessCenterAccess';
import WellnessCenterVerification from '../Surveys/ParticipantInfoConfirmation/WellnessCenterVerification';
import ReportWrapperV2 from '../Admin/Reports/Shared/ReportWrapperV2';

// Errors
import Error404 from '../Errors/Error404';

class Surveys extends Component {
  render() {
    return (
      <Switch>
        {/*
          USAGE EXAMPLE FOR isAuthorized:
          <Route path='/studentsection' component={isAuthorized(isAuthenticated(withLayout(StudentSection)), 'USER')} />
          <Route path="/admin" component={isAuthenticated(withLayout(Admin, true), { userType: 'user' })} />
        */}
        <Route path="/wellness-center" exact component={withLayout(WellnessCenterAccess, { showLogo: false })} />
        <Route path="/wellness-center/result" component={wellnessCenterAuth(withLayout(WellnessCenterVerification, { showLogo: false, showLang: true }))} />
        <Route path="/wellness-center/report/:template/:surveyParticipantId" exact component={wellnessCenterAuth(ReportWrapperV2)} /> {/* parent report V2 */}
        <Route component={withLayout(Error404, { showLogo: true, showContact: true, showUser: true, showLang: false })} />
      </Switch>
    );
  }
}

export default Surveys;
